import React from 'react';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { ClientConfig, ResultsConfig } from '../../services/module4Service';
import TabPanel from './TabPanel';

interface TabPanelResultsProps {
  config: ClientConfig;
  activeTab: number;
  handleResultsChange: (field: keyof ResultsConfig, value: any) => void;
}

const TabPanelResults: React.FC<TabPanelResultsProps> = ({
  config,
  activeTab,
  handleResultsChange
}) => {
  return (
    <TabPanel value={activeTab} index={3}>
      <Typography variant="h6" gutterBottom>Output Format</Typography>
      <TextField
        fullWidth
        label="Output Format"
        value={config.results.output_format}
        onChange={(e) => handleResultsChange('output_format', e.target.value)}
        required
      />
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Output Regex</Typography>
      <TextField
        fullWidth
        label="Output Regex"
        value={config.results.output_regex}
        onChange={(e) => handleResultsChange('output_regex', e.target.value)}
      />
      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Result Columns</Typography>
      {config.results.result_columns.map((column, index) => (
        <Box key={index} display="flex" alignItems="center" mb={1}>
          <TextField
            fullWidth
            label={`Column ${index + 1}`}
            value={column}
            onChange={(e) => {
              const newColumns = [...config.results.result_columns];
              newColumns[index] = e.target.value;
              handleResultsChange('result_columns', newColumns);
            }}
            sx={{ mr: 1 }}
          />
          <IconButton 
            color="error" 
            onClick={() => {
              const newColumns = [...config.results.result_columns];
              newColumns.splice(index, 1);
              handleResultsChange('result_columns', newColumns);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}
      <Button 
        variant="outlined" 
        startIcon={<AddIcon />} 
        onClick={() => {
          const newColumns = [...config.results.result_columns, ''];
          handleResultsChange('result_columns', newColumns);
        }}
      >
        Add Column
      </Button>
    </TabPanel>
  );
};

export default TabPanelResults;
